import NativeEventEmitter from '@framework/data-helpers/event/NativeEventEmitter';
import UsersUploadAdapter
  from '@/dataroom/infrastructure/api/FileUploadDispatcher/uploadAdapters/UsersUploadAdapter';
import { UploadProcessing, IUploadStrategy } from '@dealroadshow/file-uploader';
import { IUploadProcessingEventEmitter } from '@dealroadshow/file-uploader/dist/uploadProcessing/IUploadProcessing';
import IFileStream from '@dealroadshow/file-uploader/src/models/IFileStream';

export default class UsersUploadStrategy implements IUploadStrategy {
  constructor(protected readonly uploadAdapter: UsersUploadAdapter) {
  }

  async createUpload(
    fileStream: IFileStream,
    fileSize: number,
    fileName: string,
    options: {
      dataroomId: number,
      abortController: AbortController,
    },
  ) {
    const eventEmitter = new NativeEventEmitter();
    const uploadAdapter = this.createAdapter(this.uploadAdapter, eventEmitter);

    uploadAdapter.upload(fileStream, fileSize, {
      fileName,
      ...options,
    });

    return new UploadProcessing(
      '', // We don't have uuid in our uploadAdapter
      fileSize,
      options,
      uploadAdapter,
      // NativeEventEmitter implements .on()/.emit() used by UploadProcessing at runtime.
      // The cast is needed because the library's interface extends Node.js EventEmitter type.
      eventEmitter as unknown as IUploadProcessingEventEmitter,
    );
  }

  protected createAdapter = (adapter: UsersUploadAdapter, eventEmitter: NativeEventEmitter) => {
    const clone = Object.assign(Object.create(Object.getPrototypeOf(adapter)), adapter);
    clone.setEventEmitter(eventEmitter);
    return clone;
  };
}
